import type {
  LimitOrderAmendRequest,
  LimitOrderCancelResponse,
  LimitOrderPlacementRequest,
  LimitOrderResponse,
} from 'apiConnector/secondary-market/limit-order/models';
import type { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import type { IHttpBody, IHttpClient } from 'utils/http/httpClient.model';

export interface LimitOrderTradeApi {
  placeOrder(request: LimitOrderPlacementRequest): Observable<LimitOrderResponse>;
  amendOrder(etag: string, request: Partial<LimitOrderAmendRequest>): Observable<LimitOrderResponse>;
  cancelOrder(orderId: string): Observable<LimitOrderCancelResponse>;
}
export function limitOrderApiConnector(httpClient: IHttpClient): LimitOrderTradeApi {
  return {
    placeOrder: req => {
      return httpClient
        .postJSON<LimitOrderResponse>({
          url: 'api/v1/secondary-market/limit-order/placement',
          body: req as IHttpBody,
          timeOut: 10_000,
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    cancelOrder: orderId => {
      return httpClient
        .patch<LimitOrderCancelResponse>({
          url: 'api/v1/secondary-market/limit-order/cancel',
          body: {
            orderId: orderId,
          },
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    amendOrder: (etag, req) => {
      return httpClient
        .patch<LimitOrderResponse>({
          url: `api/v1/secondary-market/limit-order/amend?etag=${encodeURIComponent(etag)}`,
          body: req as IHttpBody,
          timeOut: 10_000,
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
